<template>
  <div :key="domKey" class="page-item">
    <div class="header">
      <base-section-title class="p-t-24 m-l-24 m-b-8" title="待办事项" />
      <nav-bar :list="dataList" @handleSelect="handleSelect" />
    </div>
    <el-scrollbar v-if="current.total" v-loading="loading">
      <div v-if="current.total" class="content">
        <div
          v-for="(item, index) in current.data"
          :key="index"
          class="list-item"
        >
          <div class="left">
            <div class="text1">
              <span v-if="current.navType == 'purchaser-todo'">
                【审批】「{{
                  item.workflowInfo.initiatorInfo.initiatorName
                }}」发起的审批单
              </span>
              <span v-if="current.navType == 'purchaser-project'">
                【{{ purchaseAllTypeDict.translate(item.purchaseType).label }}】
                {{
                  purchaserToDoListDict[item.purchaseType][item.processType]
                    .title
                }}
              </span>
              <span
                v-if="
                  current.navType == 'supplier-project' &&
                    supplierToDoListDict[item.purchaseType][item.processType]
                "
              >
                【{{ purchaseAllTypeDict.translate(item.purchaseType).label }}】
                {{
                  supplierToDoListDict[item.purchaseType][item.processType]
                    .title
                }}
              </span>
              <span v-if="current.navType == 'agency-project'">
                <span v-if="item.purchaseType">
                  【{{
                    purchaseAllTypeDict.translate(item.purchaseType).label
                  }}】
                  {{
                    agencyToDoListDict[item.purchaseType][item.processType]
                      .title
                  }}
                </span>
                <span v-else>
                  【委托】
                  {{
                    agencyToDoListDict[item.purchaseType][item.processType]
                      .title
                  }}
                </span>
              </span>
              <span v-if="current.navType == 'purchaser-signature'">
                【在线签章】「{{
                  item.initiatorInfo.initiatorName || '-'
                }}」发起文件签署
              </span>

              <!-- 履约验收 -->
              <span v-if="current.navType == 'performance'">
                {{ item.title }}
              </span>
            </div>
            <div class="text2 text-ellipsis">
              <span v-if="current.navType == 'purchaser-todo'">
                <span
                  v-for="(subtitleItem, subtitleIndex) in current.subtitle"
                  :key="subtitleIndex"
                  class="p-r-20 text3 text-ellipsis"
                  :style="{ width: subtitleItem.width }"
                >
                  {{ subtitleItem.label }}
                  <span v-if="subtitleItem.prop == 'title'">
                    {{ item.workflowInfo.name }}
                  </span>
                  <span v-if="subtitleItem.prop == 'type'">
                    {{
                      workflowBusinessObject[
                        item.workflowInfo.businessInfo.businessType
                      ]
                    }}/
                    {{
                      workflowBusinessObject[
                        item.workflowInfo.businessInfo.businessNode
                      ]
                    }}
                  </span>
                  <span v-if="subtitleItem.prop == 'time'">
                    {{ item.workflowInfo.timeInfo.startTime }}
                  </span>
                </span>
              </span>
              <span v-if="current.navType == 'purchaser-signature'">
                <span
                  v-for="(subtitleItem, subtitleIndex) in current.subtitle"
                  :key="subtitleIndex"
                  class="p-r-20 text3 text-ellipsis"
                  :style="{ width: subtitleItem.width }"
                >
                  {{ subtitleItem.label }}
                  <span v-if="subtitleItem.prop == 'title'">
                    {{ item.initiatorInfo.initiatorName || '-' }}
                  </span>
                  <span v-if="subtitleItem.prop == 'time'">
                    {{ item.timeInfo.startTime || '-' }}
                  </span>
                  <span v-if="subtitleItem.prop == 'file'">
                    {{ item.attachmentInfo.attachmentName || '-' }}
                  </span>
                </span>
              </span>
              <span
                v-if="
                  current.navType == 'purchaser-project' &&
                    supplierToDoListDict[item.purchaseType][item.processType]
                "
              >
                <span
                  v-for="(subtitleItem, subtitleIndex) in purchaserToDoListDict[
                    item.purchaseType
                  ][item.processType].subtitle"
                  :key="subtitleIndex"
                  class="p-r-20 text3 text-ellipsis"
                  :style="{ width: subtitleItem.width }"
                >
                  {{ subtitleItem.label }}
                  {{ item.customObj[subtitleItem.prop] || '-' }}
                  <span v-if="subtitleItem.unit">
                    <span v-if="subtitleItem.unit == '元'">
                      {{ strToThousands(subtitleItem.unit) }}
                    </span>
                    <span v-else>
                      {{ subtitleItem.unit }}
                    </span>
                  </span>
                </span>
              </span>
              <span v-if="current.navType == 'supplier-project'">
                <span
                  v-for="(subtitleItem, subtitleIndex) in supplierToDoListDict[
                    item.purchaseType
                  ][item.processType].subtitle"
                  :key="subtitleIndex"
                  class="p-r-20 text3 text-ellipsis"
                  :style="{ width: subtitleItem.width }"
                >
                  {{ subtitleItem.label }}
                  {{ item.customObj[subtitleItem.prop] || '-' }}
                  <span v-if="subtitleItem.unit">
                    <span v-if="subtitleItem.unit == '元'">
                      {{ strToThousands(subtitleItem.unit) }}
                    </span>
                    <span v-else>
                      {{ subtitleItem.unit }}
                    </span>
                  </span>
                </span>
              </span>
              <span v-if="current.navType == 'agency-project'">
                <span
                  v-for="(subtitleItem, subtitleIndex) in agencyToDoListDict[
                    item.purchaseType
                  ][item.processType].subtitle"
                  :key="subtitleIndex"
                  class="p-r-20 text3 text-ellipsis"
                  :style="{ width: subtitleItem.width }"
                >
                  {{ subtitleItem.label }}
                  {{ item.customObj[subtitleItem.prop] || '-' }}
                  <span v-if="subtitleItem.unit">
                    <span v-if="unit == '元'">
                      {{ strToThousands(subtitleItem.unit) }}
                    </span>
                    <span v-else>
                      {{ subtitleItem.unit }}
                    </span>
                  </span>
                </span>
              </span>

              <span v-if="current.navType == 'performance'">
                <span
                  class="p-r-20 text3 text-ellipsis"
                  :style="{ width: '50%' }"
                >
                  项目名称：{{ item.content || '-' }}
                </span>
                <span
                  class="p-r-20 text3 text-ellipsis"
                  :style="{ width: '50%' }"
                >
                  业主单位：{{ item.purchaseCompanyName || '-' }}
                </span>
              </span>
            </div>
          </div>
          <div class="right">
            <el-button
              v-if="current.navType == 'purchaser-todo'"
              type="primary"
              @click="toDoPageHandle(current, item)"
            >
              去处理
            </el-button>
            <el-button
              v-if="
                current.navType == 'purchaser-project' &&
                  purchaserToDoListDict[item.purchaseType][item.processType]
              "
              type="primary"
              @click="purchaserPageHandle(current, item)"
            >
              {{
                purchaserToDoListDict[item.purchaseType][item.processType].btn
              }}
            </el-button>
            <el-button
              v-if="
                current.navType == 'supplier-project' &&
                  supplierToDoListDict[item.purchaseType][item.processType]
              "
              type="primary"
              @click="supplierPageHandle(current, item)"
            >
              {{
                supplierToDoListDict[item.purchaseType][item.processType].btn
              }}
            </el-button>
            <el-button
              v-if="
                current.navType == 'agency-project' &&
                  agencyToDoListDict[item.purchaseType][item.processType]
              "
              type="primary"
              @click="agencyPageHandle(current, item)"
            >
              {{ agencyToDoListDict[item.purchaseType][item.processType].btn }}
            </el-button>
            <el-button
              v-if="current.navType == 'purchaser-signature'"
              type="primary"
              @click="signaturePageHandle(item)"
            >
              前往签章
            </el-button>

            <!-- 履约验收 -->
            <el-button
              v-if="current.navType == 'performance'"
              type="primary"
              @click="performancePageHandle(item)"
            >
              {{ performanceTodoDict[item.orderStatus].btnLabel }}
            </el-button>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div v-if="current.total > 0" class="pagination-box">
      <jczh-pagination
        v-if="current.total > 0"
        style="text-align: right"
        :total="current.total"
        :page.sync="current.params.page"
        :page-sizes="[5, 10, 20, 50]"
        :limit.sync="current.params.size"
        @pagination="handlePagination"
      />
    </div>
    <el-empty v-if="!current.total" :image="noData" class="no-data" />
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import NavBar from '@/views/home/components/NavBar'

import { mapState, mapActions } from 'vuex'

import { strToThousands } from '@/utils/utils'
// api
import { getCompeteHallTokenApi } from '@/api/compete'
import { getBidInfoApi } from '@/api/supplier/bid'
import { getSupplierKpbProjectApi } from '@/api/supplier/kpb-project'
import { fetchInviteBidDetailApi } from '@/api/procure/invite-bid'
import { getCompeteMesApi } from '@/api/procure/compete'
import {
  getSupplierWaitRaskPageApi,
  getPurchaserWaitRaskPageApi,
  getPerformanceWaitTaskPageApi
} from '@/api/to-do-list'
import { getWorkflowTodoApi } from '@/api/workflow'
import { getESignTaskListApi } from '@/api/signature'
import { getInquiryListApi } from '@/api/procure/inquiry'
import { fetchInviteBidListApi } from '@/api/procure/invite-bid'
import { getCompeteListApi } from '@/api/procure/compete'
import { getNegotiationV2ListApi } from '@/api/procure/negotiation-v2'
import { getDemandListApi } from '@/api/procure/demand'

// 字典
import {
  purchaseTypeDict,
  purchaseAllTypeDict
} from '@/dictionary/project/common'
import { signatureStatusDict } from '@/dictionary/signature'
import {
  purchaserToDoListDict,
  supplierToDoListDict,
  agencyToDoListDict
} from '@/dictionary/to-do-list'
import { kpbProjectStatusDict } from '@/dictionary/project/kpb-project'
import { inquiryFlowStatusDict } from '@/dictionary/project/inquiry'
import { bidFlowStatusDict } from '@/dictionary/project/bid'
import { competeStatusDict } from '@/dictionary/project/compete'
import {
  negotiationV2StatusDict,
  todoNodeDict,
  reviewNegotiationStatusDict
} from '@/dictionary/project/negotiation-v2'
import { demandsStatusDict } from '@/dictionary/project/demands'
import { workbenchServiceDict } from '@/dictionary/system'
import { performanceTodoDict } from '@/dictionary/performance'
import WujieVue from 'wujie-vue2'
import { mapMutations } from 'vuex'

const purchaseTypeList = [
  purchaseAllTypeDict.BIDDING.value,
  purchaseAllTypeDict.INQUIRY.value,
  purchaseAllTypeDict.COMPETE.value,
  purchaseAllTypeDict.NEGOTIATION.value,
  purchaseAllTypeDict.NEGOTIATION_V2.value
]

const agencyPurchaseTypeList = [
  purchaseAllTypeDict.BIDDING.value,
  purchaseAllTypeDict.INQUIRY.value,
  purchaseAllTypeDict.COMPETE.value
]

export default {
  name: 'HomeToDoList',

  components: {
    BaseSectionTitle,
    NavBar
  },

  data() {
    return {
      purchaseTypeDict,
      purchaseAllTypeDict,
      purchaserToDoListDict,
      supplierToDoListDict,
      agencyToDoListDict,
      workbenchServiceDict,
      performanceTodoDict,

      domKey: 1,
      bidderId: '',
      kpbProjectId: '',
      kpbProjectStatus: '',
      noData: require('@/assets/images/home/ToDoList-no-data.png'),
      loading: false,
      purchaser: [
        {
          navTitle: '报名审核',
          navType: 'purchaser-project',
          api: getPurchaserWaitRaskPageApi,
          data: [],
          subtitle: [],
          total: 0,
          params: {
            page: 1,
            size: 5,
            finished: false,
            processType: '1', // 待办任务类型
            purchaseTypes: purchaseTypeList // 采购类型
          }
        },
        {
          navTitle: '项目待办',
          navType: 'purchaser-project',
          api: getPurchaserWaitRaskPageApi,
          data: [],
          subtitle: [],
          total: 0,
          params: {
            page: 1,
            size: 5,
            finished: false
          }
        },
        {
          navTitle: '审批待办',
          navType: 'purchaser-todo',
          api: getWorkflowTodoApi,
          data: [],
          subtitle: [
            {
              label: '审批标题名称：',
              prop: 'title',
              width: '40%'
            },
            {
              label: '审批类型：',
              prop: 'type',
              width: '30%'
            },
            {
              label: '提交时间：',
              prop: 'time',
              width: '30%'
            }
          ],
          total: 0,
          params: {
            page: 1,
            size: 5
          }
        },
        {
          navTitle: '履约验收',
          navType: 'performance',
          api: getPerformanceWaitTaskPageApi,
          data: [],
          subtitle: [],
          total: 0,
          params: {
            page: 1,
            size: 5
          }
        }
      ],
      supplier: [
        {
          navTitle: '项目待办',
          navType: 'supplier-project',
          api: getSupplierWaitRaskPageApi,
          data: [],
          subtitle: [],
          total: 0,
          params: {
            page: 1,
            size: 5,
            finished: false
          }
        },
        {
          navTitle: '履约验收',
          navType: 'performance',
          api: getPerformanceWaitTaskPageApi,
          data: [],
          subtitle: [],
          total: 0,
          params: {
            page: 1,
            size: 5
          }
        }
      ],
      agency: [
        {
          navTitle: '报名审核',
          navType: 'agency-project',
          api: getPurchaserWaitRaskPageApi,
          data: [],
          total: 0,
          params: {
            page: 1,
            size: 5,
            finished: false,
            processType: '1', // 待办任务类型
            purchaseTypes: agencyPurchaseTypeList // 采购类型
          }
        },
        {
          navTitle: '项目待办',
          navType: 'agency-project',
          api: getPurchaserWaitRaskPageApi,
          data: [],
          total: 0,
          params: {
            page: 1,
            size: 5,
            finished: false
          }
        },
        {
          navTitle: '审批待办',
          navType: 'purchaser-todo',
          api: getWorkflowTodoApi,
          data: [],
          subtitle: [],
          total: 0,
          params: {
            page: 1,
            size: 5
          }
        },
        {
          navTitle: '履约验收',
          navType: 'performance',
          api: getPerformanceWaitTaskPageApi,
          data: [],
          subtitle: [],
          total: 0,
          params: {
            page: 1,
            size: 5
          }
        }
      ],
      signature: {
        navTitle: '签章待办',
        navType: 'purchaser-signature',
        api: getESignTaskListApi,
        data: [],
        subtitle: [
          {
            label: '发起人：',
            prop: 'title',
            width: '30%'
          },
          {
            label: '发起时间：',
            prop: 'time',
            width: '30%'
          },
          {
            label: '文件名：',
            prop: 'file',
            width: '40%'
          }
        ],
        total: 0,
        params: {
          page: 1,
          size: 5,
          status: signatureStatusDict.TO_BE_SIGNED.value,
          type: 2
        }
      },
      index: 0,
      dataList: [],
      isChangeTab: false,
      current: {
        data: [],
        navTitle: '',
        navType: '',
        api: '',
        subtitle: [],
        total: 0,
        params: {
          page: 1,
          size: 5
        }
      }
    }
  },

  computed: {
    ...mapState('user', ['isSigner']),
    ...mapState('router', ['currentWorkbench']),
    ...mapState('workflow', ['workflowBusinessList', 'workflowBusinessObject']),
    // 获取当前路由参数，跳转路由前缀，代理机构加上Agency
    entrustRouter() {
      if (this.isIdentity == 'agency') {
        return 'Agency'
      }
      return ''
    },
    purchaseTypeList() {
      const arr = []
      purchaseTypeDict.array.map(item => {
        arr.push(item.value)
      })
      return arr
    },
    // 获取当中工作台身份
    isIdentity() {
      return workbenchServiceDict.translate(this.currentWorkbench)?.alias
    }
  },

  watch: {
    currentWorkbench: {
      handler: function(val) {
        if (val) {
          this.getWorkflowBusinessDict()
          this.index = 0
          this.getLIst()
        }
      },
      immediate: true
    }
  },

  mounted() {
    const _this = this
    window.onresize = () => {
      this.domKey++
    }
  },

  destroyed() {
    window.onresize = null
  },

  methods: {
    ...mapActions('workflow', ['getWorkflowBusinessDict']),
    ...mapMutations('router', {
      clearCacheView: 'CLEAR_CACHE_VIEW'
    }),

    strToThousands,

    async getLIst() {
      this.dataList = this[this.isIdentity]
      if (
        this.isSigner &&
        this.dataList[this.dataList.length - 1].navType != 'purchaser-signature'
      ) {
        this.dataList.push(this.signature)
      }

      this.dataList.map((item, index) => {
        this.loading = true
        item
          .api(item.params)
          .then(res => {
            item.data = res.data.records || []
            item.total = res.data.total
            this.loading = false
            if (!index) {
              this.current = item
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err?.message || err)
          })
      })
    },

    handleSelect(key, item) {
      this.isChangeTab = true
      this.index = Number(key)
      this.current = this.dataList[this.index]
      this.current.params.page = 1
      if (item.navType == 'purchaser-todo') {
        this.getWorkflowTodoList()
      }
      if (item.navType == 'purchaser-signature') {
        this.getESignTaskList()
      }
      if (
        item.navType == 'purchaser-project' ||
        item.navType == 'agency-project'
      ) {
        this.getWaitRaskPageList(getPurchaserWaitRaskPageApi)
      }
      if (item.navType == 'supplier-project') {
        this.getWaitRaskPageList(getSupplierWaitRaskPageApi)
      }
      if (item.navType == 'performance') {
        this.getPerformanceList()
      }
      setTimeout(() => {
        this.isChangeTab = false
      }, 1000)
    },
    // 获取审批待办列表
    getWorkflowTodoList() {
      const params = {
        page: this.current.params.page,
        size: this.current.params.size
      }
      this.loading = true
      getWorkflowTodoApi(params)
        .then(res => {
          this.current.data = res.data.records || []
          this.current.total = res.data.total
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err?.message || err)
        })
    },

    // 获取项目待办列表
    getWaitRaskPageList(api) {
      this.loading = true
      this.current
        .api(this.current.params)
        .then(res => {
          this.current.data = res.data.records || []
          this.current.total = res.data.total
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err?.message || err)
        })
    },

    // 获取签章待办列表
    getESignTaskList() {
      const params = {
        page: this.current.params.page,
        size: this.current.params.size,
        status: signatureStatusDict.TO_BE_SIGNED.value,
        type: 2
      }
      this.loading = true
      getESignTaskListApi(params)
        .then(res => {
          this.current.data = res.data.records || []
          this.current.total = res.data.total
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err?.message || err)
        })
    },

    // 获取履约待办列表
    getPerformanceList() {
      const params = {
        page: this.current.params.page,
        size: this.current.params.size
      }
      this.loading = true
      getPerformanceWaitTaskPageApi(params)
        .then(res => {
          this.current.data = res.data.records || []
          this.current.total = res.data.total
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err?.message || err)
        })
    },

    handlePagination(val) {
      if (this.isChangeTab) return
      this.current.params.size = val.limit
      this.current.params.page = val.page
      if (this.current.navType == 'purchaser-todo') {
        this.getWorkflowTodoList()
      }
      if (
        this.current.navType == 'purchaser-project' ||
        this.current.navType == 'agency-project'
      ) {
        this.getWaitRaskPageList(getPurchaserWaitRaskPageApi)
      }
      if (this.current.navType == 'supplier-project') {
        this.getWaitRaskPageList(getSupplierWaitRaskPageApi)
      }
      if (this.current.navType == 'purchaser-signature') {
        this.getESignTaskList()
      }
      // 获取履约验收待办列表
      if (this.current.navType == 'performance') {
        this.getPerformanceList()
      }
    },

    // 审批待办跳转处理
    toDoPageHandle(current, item) {
      const params = {
        workflowId: item.workflowId,
        taskId: item.taskId ? item.taskId : null,
        identity: 'otherIdentity'
      }
      // 五菱审批
      if (
        item.workflowInfo.businessInfo.businessType === 'wu_ling_bidding_order'
      ) {
        this.$router
          .push({
            name: 'WlToDoListAuditDetail'
          })
          .catch(() => {})
        WujieVue.bus.$emit('routerChange', {
          menuName: 'WlToDoListAuditDetail',
          params
        })
      } else {
        const routerObj = {
          name: 'ToDoListAuditDetail',
          params
        }
        this.jumpPage(routerObj)
      }
    },

    // 采购人审批待办跳转处理
    purchaserPageHandle(current, item) {
      const routerNmae =
        purchaserToDoListDict[item.purchaseType][item.processType].routerNmae
      const pageType =
        purchaserToDoListDict[item.purchaseType][item.processType].pageType ||
        ''
      const routerObj = {
        name: routerNmae,
        params: {}
      }
      // 招标-供应商报名审核页
      if (routerNmae == 'BiddingApplyReview') {
        routerObj.params = {
          tradeId: item.customObj.trade_id,
          supplierId: item.customObj.supplier_id,
          orderId: item.orderId
        }
      }
      // 询比-供应商报价审核
      if (routerNmae == 'InquiryApprovalCheck') {
        routerObj.params = {
          tradeId: item.customObj.trade_id,
          orderId: item.orderId
        }
      }
      // 竞价-供应商报名审核页
      if (routerNmae == 'SignUpDetail') {
        routerObj.params = {
          tradeId: item.customObj.trade_id,
          orderId: item.orderId,
          method: 'detail'
        }
      }
      // 谈判-供应商报价审核页
      if (routerNmae == 'NegotiationSupplierAudit') {
        routerObj.params = {
          tradeId: item.customObj.trade_id,
          orderId: item.orderId
        }
      }
      // 分项谈判-供应商报价审核页
      if (routerNmae == 'NegotiationV2SupplierDetail') {
        routerObj.params = {
          orderId: item.orderId,
          applyId: item.customObj.apply_id
        }
      }
      // 跳转至中转页
      if (routerNmae == 'HomeTransfer') {
        this.goListPage(item.orderCode, item.orderId, item.orderName, pageType)
        return
      }
      // 前往开评标大厅-竞价大厅
      if (routerNmae == 'Transit') {
        const params = {
          pageType: pageType,
          identity: 'purchaser',
          orderId: item.orderId,
          tradeId: item.customObj.tradeId,
          projectId: item.projectId
        }
        if (pageType == 'PurchaserBidOpenHallHome') {
          this.fetchInviteBidDetail(params)
        }
        if (pageType == 'SupplierCompeteHall') {
          this.getCompeteMes(params)
        }
        return
      }
      this.jumpPage(routerObj)
    },

    // 供应商审批待办跳转处理
    supplierPageHandle(current, item) {
      const routerNmae =
        supplierToDoListDict[item.purchaseType][item.processType].routerNmae
      const pageType =
        supplierToDoListDict[item.purchaseType][item.processType].pageType || ''
      const routerObj = {
        name: routerNmae,
        params: {}
      }
      // 招标-供应商报名页
      if (
        routerNmae == 'SupplierPurchaseSignUp' ||
        routerNmae == 'SupplierInquiryTrade' ||
        routerNmae == 'SupplierCompeteSignUp' ||
        routerNmae == 'SupplierNegotiationTrade' ||
        routerNmae == 'SupplierNegotiationV2Trade'
      ) {
        routerObj.params = {
          orderId: item.orderId,
          tradeId: item.tradeId
        }
      }
      // 前往开评标大厅-竞价大厅
      if (routerNmae == 'Transit') {
        const params = {
          pageType: pageType,
          identity: 'supplier',
          orderId: item.orderId,
          tradeId: item.tradeId,
          projectId: item.projectId
        }
        this.fetchBidInfo(params)
        return
      }
      this.jumpPage(routerObj)
    },

    // 供应商审批待办跳转处理
    agencyPageHandle(current, item) {
      const routerNmae =
        agencyToDoListDict[item.purchaseType][item.processType].routerNmae
      const pageType =
        agencyToDoListDict[item.purchaseType][item.processType].pageType || ''
      const routerObj = {
        name: routerNmae,
        params: {}
      }
      // 招标-供应商报名页
      if (routerNmae == 'AgencyInviteBidApplyForm') {
        routerObj.params = {
          tradeId: item.customObj.trade_id,
          supplierId: item.customObj.supplier_id,
          orderId: item.orderId
        }
      }
      // 询比-供应商报价审核
      if (routerNmae == 'AgencyInquiryApprovalCheck') {
        routerObj.params = {
          tradeId: item.customObj.trade_id,
          orderId: item.orderId
        }
      }
      // 竞价-供应商报名审核页
      if (routerNmae == 'AgencySignUpDetail') {
        routerObj.params = {
          tradeId: item.customObj.trade_id,
          orderId: item.orderId,
          method: 'detail'
        }
      }
      // 前往开评标大厅-竞价大厅
      if (routerNmae == 'Transit') {
        const params = {
          pageType: pageType,
          identity: 'agency',
          tradeId: item.customObj.trade_id,
          orderId: item.orderId,
          projectId: item.projectId
        }
        if (pageType == 'PurchaserBidOpenHallHome') {
          this.fetchInviteBidDetail(params)
        }
        if (pageType == 'SupplierCompeteHall') {
          this.getCompeteMes(params)
        }
      }
      // 跳转至中转页
      if (routerNmae == 'HomeTransfer') {
        this.goListPage(item.orderCode, item.orderId, item.orderName, pageType)
        return
      }
      // 代理采购待办详情
      if (routerNmae == 'AgencyEntrustDetail') {
        routerObj.params = {
          projectId: item.orderId
        }
      }
      this.jumpPage(routerObj)
    },

    // 签章待办处理
    signaturePageHandle(task) {
      const routerObj = {
        name: 'SignatureTask',
        params: {}
      }
      this.jumpPage(routerObj)
    },

    // 页面跳转
    jumpPage(pageInfo) {
      this.$router.push(pageInfo)
    },

    // 获取供应商招标详情
    fetchBidInfo(params) {
      const tempForm = {
        orderId: params.orderId,
        tradeId: 0
      }
      getBidInfoApi(tempForm)
        .then(res => {
          this.bidderId = res.data.bidderId || ''
          this.kpbProjectId = res.data.kpbProjectId || ''
          getSupplierKpbProjectApi(this.kpbProjectId)
            .then(kpbRes => {
              this.kpbProjectStatus = kpbRes.data.projectStatus || ''
              this.goSupplierPage(params)
            })
            .catch(err => {
              this.$message.error(err.message || '获取失败')
            })
        })
        .catch(err => {
          this.$message.error(err.message || '获取失败')
        })
    },
    goSupplierPage(params) {
      if (params.pageType === 'SupplierCompeteHall') {
        // 前往竞价大厅
        this.joinSupplierCompeteHall(params)
      }
      if (params.pageType === 'SupplierBidOpenHallHome') {
        // 前往开标大厅
        this.toBidOpenHall(params)
      }
      if (params.pageType === 'SupplierReviewSession') {
        // 前往评标大厅
        this.toReviewHall(params)
      }
    },
    // 获取供应商详情 getBidInfoApi
    joinSupplierCompeteHall(params) {
      getCompeteHallTokenApi(
        { identity: 1, tradeId: params.tradeId },
        params.orderId
      )
        .then(res => {
          this.$router.push({
            name: 'SupplierCompeteHall',
            params: { token: res.data.token }
          })
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    toBidOpenHall(params) {
      const routeName =
        this.kpbProjectStatus >= kpbProjectStatusDict.OPEN_BID_STARTED.value
          ? 'SupplierBidOpenHallHome'
          : 'SupplierBidOpenHallDoor'

      this.$router.push({
        name: routeName,
        params: {
          projectId: this.kpbProjectId,
          bidderId: this.bidderId
        }
      })
    },

    toReviewHall(params) {
      const routeUrl = this.$router.resolve({
        name: 'SupplierBidReviewHallHome',
        params: {
          projectId: this.kpbProjectId,
          bidderId: this.bidderId
        }
      })
      window.open(routeUrl.href, '_blank')
    },

    // 前往开标大厅
    fetchInviteBidDetail(params) {
      fetchInviteBidDetailApi({ orderId: params.orderId })
        .then(res => {
          this.bidderId = res.data.bidderId || ''
          this.kpbProjectId = res.data.kpbProjectId || ''
          this.kpbProjectStatus = res.data.kpbProjectStatus
          this.goPurchaserPage(params)
        })
        .catch(err => {
          this.$message.error(err.message || '获取失败')
        })
    },

    // 前往竞价大厅需要该接口
    getCompeteMes(params) {
      getCompeteMesApi(params.orderId)
        .then(res => {
          this.bidderId = res.data.bidderId || ''
          this.kpbProjectId = res.data.kpbProjectId || ''
          this.kpbProjectStatus = res.data.kpbProjectStatus
          this.goPurchaserPage(params)
        })
        .catch(err => {
          this.$message.error(err.message || '获取失败')
        })
    },

    // 页面跳转
    goPurchaserPage(params) {
      // 前往竞价大厅
      if (params.pageType === 'PurchaserCompeteHall') {
        this.purchaserJoinCompeteHall(params)
      }
      // 前往开标大厅
      if (params.pageType === 'PurchaserBidOpenHallHome') {
        this.purchaserToBidOpenHall(params)
      }
      // 前往评标大厅
      // if (params.pageType === '') {
      //   this.toReviewHall(params)
      // }
    },
    purchaserToBidOpenHall(params) {
      let routeName =
        this.kpbProjectStatus >= kpbProjectStatusDict.OPEN_BID_STARTED.value
          ? 'BidOpenHallHome'
          : 'BidOpenHallDoor'
      if (params.identity == 'agency') {
        routeName = 'Agency' + routeName
      }
      this.$router.push({
        name: routeName,
        params: {
          projectId: this.kpbProjectId
        }
      })
    },
    // 前往竞价大厅
    purchaserJoinCompeteHall(params) {
      getCompeteHallTokenApi({ identity: 2 }, params.orderId)
        .then(res => {
          this.$router.push({
            name:
              params.identity == 'agency' ? 'AgencyCompeteHall' : 'CompeteHall',
            params: { token: res.data.token }
          })
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // 暂不跳转至评标
    purchaserToReviewHall(params) {
      const routeUrl = this.$router.resolve({
        name:
          params.identity == 'agency'
            ? 'AgencyLeaderRecommend'
            : 'LeaderRecommend',
        params: {
          // 评审项目id
          projectId: this.kpbProjectId
        }
      })
      window.open(routeUrl.href, '_blank')
    },

    // 查询出列表数据再模拟列表跳转行为
    goListPage(orderCode, orderId, orderName, pageType) {
      if (pageType == 'InquiryDetail') {
        this.getInquiryList(orderCode, orderId, orderName, pageType)
      }
      if (pageType == 'InviteBidDetail') {
        this.getInviteBidList(orderCode, orderId, orderName, pageType)
      }
      if (pageType == 'competitionDetail') {
        this.getCompeteList(orderCode, orderId, orderName, pageType)
      }
      if (pageType == 'demandDetail') {
        this.getDemandList(orderCode, orderId, orderName, pageType)
      }
      if (pageType == 'NegotiationDetail') {
        this.getNegotiationList(orderCode, orderId, orderName, pageType)
      }
      if (pageType == 'NegotiationV2Detail') {
        this.getNegotiationV2List(orderCode, orderId, orderName, pageType)
      }
    },
    // 获取招标列表
    async getInviteBidList(orderCode, orderId, orderName, pageType) {
      const requestParams = {
        page: 1,
        size: 10,
        orderId: orderId
      }

      try {
        const _data = await fetchInviteBidListApi(requestParams)
        const row = _data.data.records[0]
        this.InviteBidDetail(row)
      } catch (err) {
        this.$message.error(err.message || '获取招标列表失败')
      }
    },
    /**
     * 查看招标详情
     */
    InviteBidDetail(row) {
      let routerName = ''
      if (row.orderFlowStatus) {
        routerName = bidFlowStatusDict.translate(row.orderFlowStatus).routerName
      } else {
        routerName = bidFlowStatusDict.translate(row.status).routerName
      }

      const status = row.orderFlowStatus || row.status
      if (Number(status) === bidFlowStatusDict.REGISTER_CLOSED.value) {
        if (row.bidOpened) {
          // 当报名已经截止，且未到开标时间时候，跳转到报名已截止页面
          // 到了开标时间后，跳转到候选人页面
          routerName = 'BiddingCandidate'
        }

        // 如果是线上开评标项目，则在报名已截止后，需要判断开评标项目状态进行跳转
        if (row.kpbProjectId) {
          if (row.kpbProjectStatus >= kpbProjectStatusDict.PUBLISHED.value) {
            routerName = 'BiddingOpenStep'
          }
          if (
            row.kpbProjectStatus >=
            kpbProjectStatusDict.EVALUATION_STARTED.value
          ) {
            routerName = 'BiddingReviewStep'
          }
        }
      }

      // 委托情况下，采购人只能查看委托，而代理机构可以编辑
      if (routerName === 'BiddingForm' && this.onlyLook) {
        routerName = 'BiddingInfo'
      }
      this.$router
        .push({
          name: this.entrustRouter + routerName,
          params: { orderId: row.orderId }
        })
        .catch(() => {})
    },

    // 获取询比列表
    async getInquiryList(orderCode, orderId, orderName, pageType) {
      const requestParams = {
        page: 1,
        size: 10,
        orderId: orderId
      }

      try {
        const _data = await getInquiryListApi(requestParams)
        const row = _data.data.records[0]
        this.InquiryDetail(row)
      } catch (err) {
        this.$message.error(err.message || '获取招标列表失败')
      }
    },
    //  跳转至询比详情
    InquiryDetail(row) {
      let routerName = ''
      // 有审批流取审批流的流程
      if (row.orderFlowStatus) {
        routerName = inquiryFlowStatusDict.translate(row.orderFlowStatus)
          .routerName
      } else {
        routerName = inquiryFlowStatusDict.translate(row.orderStatus).routerName
      }
      this.$router
        .push({
          name: this.entrustRouter + routerName,
          params: {
            orderId: row.orderId,
            orderName: row.orderName,
            projectId: row.projectId
          }
        })
        .catch(() => {})
    },

    // 获取竞价列表
    async getCompeteList(orderCode, orderId, orderName, pageType) {
      const requestParams = {
        page: 1,
        size: 10,
        orderId: orderId
      }

      try {
        const _data = await getCompeteListApi(requestParams)
        const row = _data.data.records[0]
        this.competeDetail(row)
      } catch (err) {
        this.$message.error(err.message || '获取招标列表失败')
      }
    },
    // 跳转至竞价详情页
    competeDetail(row) {
      const routerName = competeStatusDict.translate(row.status).routerName

      this.$router
        .push({
          name: this.entrustRouter + routerName,
          params: { orderId: row.orderId }
        })
        .catch(() => {})
    },

    // 获取需求调查列表
    async getDemandList(orderCode, orderId, orderName, pageType) {
      const requestParams = {
        page: 1,
        size: 10,
        orderId: orderId
      }

      try {
        const _data = await getDemandListApi(requestParams)
        const row = _data.data.records[0]
        this.demandDetail(row)
      } catch (err) {
        this.$message.error(err.message || '获取招标列表失败')
      }
    },

    // 跳转至需求调查详情页
    demandDetail(row) {
      const routerName = demandsStatusDict.translate(row.orderStatus).routerName

      this.$router
        .replace({
          name: routerName,
          params: { orderId: row.orderId }
        })
        .catch(() => {})
    },

    // 获取谈判采购列表
    async getNegotiationList(orderCode, orderId, orderName, pageType) {
      const requestParams = {
        page: 1,
        size: 10,
        negotiateType: 1,
        orderId: orderId
      }

      try {
        const _data = await getNegotiationV2ListApi(requestParams)
        const row = _data.data.records[0]
        this.NegotiationDetail(row)
      } catch (err) {
        this.$message.error(err.message || '获取招标列表失败')
      }
    },
    // 跳转至谈判采购详情
    NegotiationDetail(row) {
      if (row.orderStatus === negotiationV2StatusDict.RESPONSE_END.value) {
        const routerObj = {
          [reviewNegotiationStatusDict.INIT.value]: 'NegotiationResponse',
          [reviewNegotiationStatusDict.DOING.value]: 'NegotiationReview',
          [reviewNegotiationStatusDict.FINISH.value]: 'NegotiationCandidate'
        }
        this.$router
          .push({
            name: this.entrustRouter + routerObj[row.reviewStatus],
            params: {
              orderId: row.orderId
            }
          })
          .catch(() => {})
      } else {
        this.$router
          .push({
            name:
              this.entrustRouter +
              negotiationV2StatusDict.translate(row.status).routerCommonName,
            params: {
              orderId: row.orderId
            }
          })
          .catch(() => {})
      }
    },

    // 获取谈判采购列表
    async getNegotiationV2List(orderCode, orderId, orderName, pageType) {
      const requestParams = {
        page: 1,
        size: 10,
        orderId: orderId
      }

      try {
        const _data = await getNegotiationV2ListApi(requestParams)
        const row = _data.data.records[0]
        this.NegotiationV2Detail(row)
      } catch (err) {
        this.$message.error(err.message || '获取招标列表失败')
      }
    },
    // 跳转至分项谈判详情
    NegotiationV2Detail(row) {
      if (row.todoNode === todoNodeDict.CANDIDATE.value) {
        this.$router
          .push({
            name: 'NegotiationV2Candidate',
            params: {
              orderId: row.orderId
            }
          })
          .catch(() => {})
      } else {
        this.$router
          .push({
            name: negotiationV2StatusDict.translate(row.orderStatus).routerName,
            params: {
              orderId: row.orderId
            }
          })
          .catch(() => {})
      }
    },

    // 跳转至履约验收
    performancePageHandle(item) {
      const transitRouterName =
        performanceTodoDict[item.orderStatus].transitRouterName
      const targetRouterName =
        performanceTodoDict[item.orderStatus].targetRouterName
      const needOrderId = performanceTodoDict[item.orderStatus].needOrderId
      const query = { targetRouterName: targetRouterName, pageFrom: 'todoList' }
      if (needOrderId) {
        query.orderId = item.businessId
        // query.orderId = 69
      }
      console.log('query', query)
      this.clearCacheView()
      this.$router
        .push({
          name: transitRouterName,
          query: query
        })
        .catch(() => {})
      WujieVue.bus.$emit('routerChange', {
        menuName: transitRouterName,
        query: query
      })
    }
  }
}
</script>

<style scoped lang="scss">
.page-item {
  background: $white-color;
  margin: 8px 8px 16px 8px;
  box-sizing: border-box;
  border: 1px solid $primary-second-color;
  padding: 0;
  .header {
    background: linear-gradient(180deg, #edf6ff 0%, #ffffff 100%) !important;
  }
  .content {
    height: 424px;
  }
  .list-line {
    background: $info-fourth-color;
    height: 1px;
    width: 100%;
  }
  .no-list-line {
    display: none;
  }
  .list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    // padding: 16px 0;
    padding: 16px 24px;
    box-sizing: border-box;
    &:after {
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      background: $info-fourth-color;
      height: 1px;
      width: 100%;
      content: '';
    }
    &:hover {
      background: $info-fifth-color;
      cursor: pointer;
    }
    &:last-child::after {
      display: none;
    }
    &:first-child {
      padding-top: 24px;
    }
    .left {
      width: calc(100% - 100px);
      .text1 {
        font-size: 14px;
        @include text-bold;
        color: $text-color;
      }
      .text2 {
        font-size: 14px;
        margin-top: 10px;
        color: $third-text-color;
        .text3 {
          display: inline-block;
        }
      }
    }
    .right {
      width: 140px;
      display: flex;
      text-align: right;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
.status-primary {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: $primary-color;
  border-radius: 50%;
  content: ' ';
}
.no-data {
  height: 643px;
}
.pagination-box {
  margin-right: 0px;
  margin-top: -17px;
}
</style>
